import { memo } from "react";
import { colors, css, useMediaQuery, frames } from "../../Styles"
import { NewButtonList } from "./newButton";
import { ButtonTypes, ListStyle_Types, NewFieldStyles, SelectFieldOption_Values } from "../../Definitions";
import NewSelect from "./newSelect";

// #region | PageHeader Component
interface pageHeader_Props {
  topHeader?: string
  subHeader?: string
  zindex?: number
  optionButtons?: {
    contents: string[];
    onClick: (i: number) => void;
  }
  subContent?: JSX.Element;
  subSelect?: {
    options: SelectFieldOption_Values[];
    onChange: ((selectedOption: SelectFieldOption_Values | undefined) => void) | undefined
    defaultValue: SelectFieldOption_Values | undefined;
  }
}
/**
 * PageHeader
 * @param topHeader "h1" title on page.
 * @param subHeader "h2" title on page.
 * @returns topHeader and subHeader.
 */
function PageHeader({ topHeader, subHeader, zindex, optionButtons, subSelect, subContent }: pageHeader_Props) {
  const hideBtns = useMediaQuery(`(max-width: 700px)`);
  
  return (
    <frames._page_inner_header style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", width: "100%", zIndex: zindex ? zindex : 9999}}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
        <p style={{ ...css.topHeader }}>{topHeader}</p>
        { subHeader && <p style={{ ...css.subHeader }}>{subHeader}</p> }
        { subSelect && <div style={{ }}>
          <NewSelect
            options={subSelect.options}
            fieldOverrides={{
              fieldStyle: NewFieldStyles.greyDarkPrimary,              
            }}
            onChange={subSelect.onChange}  
            isSearchable
            valueOverrides={{ defaultValue: subSelect.defaultValue }}
          />
        </div> }
      </div>

      { optionButtons && <div style={{}}>
        <NewButtonList
          contents={optionButtons.contents} 
          onClick={(i => {
            if (optionButtons.onClick) optionButtons.onClick(i);
          })}
          buttonType={hideBtns ? ButtonTypes.glyphButton : ButtonTypes.primaryButton}
          overrides={{
            baseStyles: { ...( !hideBtns ? { width: "fit-content", minWidth: "none" } : {backgroundColor: colors.greyDarkSecondary})},
          }}
          listOverrides={{
            listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
          }}
          popOverrides={{
            hasPop: !hideBtns ? false : true,
            popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
            openContent: "",
            buttonType: ButtonTypes.primaryButton,
          }}              
        />
      </div>}
      
      {subContent && subContent} 
    </frames._page_inner_header>
  )
} 

export default memo(PageHeader);